/**
 * Created by andrey on 26.02.2026
 *
 * https://drive.google.com/file/d/1230-w1t5Tp35lNj61OL3y1yBU4dujNp0/view
 * Up to 1,048,576 length (1MB) of json object data can be saved for each player per game.
 *
 * No need save full data - setDataAsync merge keys with existing data.
 * Works only for logged in users.
 */

class SamsungTransportAdapter {
    constructor() {
        this.bucketData = new BucketsTransportData(32);
    }

    saveData(data, options, onSuccess, onFailure) {
        let bucketsData = {};

        if (options.syncout) {
            bucketsData = this.bucketData.clearData();
        }

        bucketsData = Object.assign(bucketsData, this.bucketData.addData(data));
        bucketsData = SyncTransportUtils.serializeValues(bucketsData);

        GSInstant.setDataAsync(bucketsData)
            .then(onSuccess)
            .catch(onFailure);
    }

    loadSession(onSuccess, onFailure) {
        const sessionBucketKey = this.bucketData.getSessionBucketKey();

        GSInstant.getDataAsync([sessionBucketKey])
            .then((data) => {
                data = SyncTransportUtils.deserializeValues(data);

                data = this.bucketData.parseResponse(data);
                onSuccess(data && data.session);
            })
            .catch(onFailure);
    }

    loadData(onSuccess, onFailure) {
        const bucketKeys = this.bucketData.getAllBucketKeys();

        GSInstant.getDataAsync(bucketKeys)
            .then((data) => {
                if (Math.random() < 0.01) {
                    this.logData(data);
                }

                data = SyncTransportUtils.deserializeValues(data);

                this.bucketData.setData({ ...data });

                data = this.bucketData.parseResponse(data);
                onSuccess(data);
            })
            .catch((error) => {
                const message = error && (error.message || error);
                const needReset = typeof message === "string" && message.includes("parsing exception");

                if (needReset) {
                    this.resetData(onSuccess, onFailure);
                } else {
                    onFailure(error);
                }
            });
    }

    resetData(onSuccess, onFailure) {
        const bucketKeys = this.bucketData.getAllBucketKeys();
        const userId = connector.platform.getUserID();

        connector.platform.getPlugin().bus.trigger("stream:console", "SAMSUNG_SYNC", `${userId} resetData start`);

        const data = {};
        bucketKeys.forEach((key) => {
            data[key] = "{}";
        });

        GSInstant.setDataAsync(data).then(() => {
            this.bucketData.setData({});
            onSuccess({});

            connector.platform.getPlugin().bus.trigger("stream:console", "SAMSUNG_SYNC", `${userId} resetData success`);
        }).catch((error) => {
            const errorMessage = error && (error.message || error);

            onFailure(error);

            connector.platform.getPlugin().bus.trigger("stream:console", "SAMSUNG_SYNC", `${userId} resetData failure - ${errorMessage}`);
        });
    }

    logData(data) {
        const userId = connector.platform.getUserID();

        const compact = Object.keys(data).reduce((acc, key) => {
            acc[key] = SyncTransportUtils.toString(data[key]);
            if (acc[key].length > 20) {
                acc[key] = `${acc[key].substring(0, 20)}...`;
            }
            return acc;
        }, {});

        connector.platform.getPlugin().bus.trigger("stream:console", "SAMSUNG_SYNC", `${userId} logData ${JSON.stringify(compact)}`);
    }
}